import { useEffect, useState } from 'react';
import ISupportRepository from '../../2_domain/support/iSupportRepository';
import { Support, SupportCategory } from '../../2_domain/support/support';
import wrapPromise from '../../lib/asyncBounrdary/wrapPromise';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';

const emptyPageResult: Page = {
  totalElements: 0,
  pageNumber: 0,
};
const useSupportPageController = () => {
  const supportRepo = Get.find<ISupportRepository>('ISupportRepository');
  const categories = wrapPromise<void, SupportCategory[]>(
    supportRepo.getAllCategories,
    undefined,
    'supportRepoKey'
  )();
  const pageSize = 10;
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const [supports, setSupports] = useState<Support[]>([]);
  const [pageResult, setPageResult] = useState<Page>(emptyPageResult);
  const [pageNumber, setPageNumber] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const loadCategory = async () => {
    setIsLoading(true);
    const pagination: Pagination = {
      pageSize: pageSize,
      pageNumber: pageNumber,
      isAscending: true,
    };
    await promiseResolver({
      promise: supportRepo.getAllSupportsByCategory(
        selectedCategory.category,
        pagination
      ),
      successCallback: (ret) => {
        setSupports(ret.list);
        setPageResult(ret.page);
      },
    });
    setIsLoading(false);
  };

  useEffect(() => {
    loadCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory, pageNumber]);

  return {
    categories,
    supports,
    pageNumber,
    setPageNumber,
    pageResult,
    selectedCategory,
    setSelectedCategory,
    pageSize,
    isLoading,
  };
};

export default useSupportPageController;
